import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  ButtonIcon,
  FormHeader,
  ImageComponent,
  InputBox,
  RadioButton,
  TabComponent,
  Uploader,
} from "../../../components";
import {
  clearSelectNews,
  closeAddUpdateNewsModal,
} from "../../news/redux/actions";
import { CheckValidity } from "../../../utils/formValidity";
import Sinhala from "../../CreateNewItem/CreateNewNews/sinhala";
import English from "../../CreateNewItem/CreateNewNews/english";
import Scrollbars from "react-custom-scrollbars-2";
import GalleryUploader from "../../templates/galleryUploader";
import { addUpdateNews } from "../../news/service/news.service";
import { Store } from "react-notifications-component";
import { getLanguage } from "../../../utils/environment";
import { deleteImage } from "../../../components/imageComponent/service/upload.service";

const lan = getLanguage();

const Index = (props) => {
  const [viewPointWidth, setViewPointWidth] = useState(0);
  const [viewPointHeight, setViewPointHeight] = useState(0);
  const [finish, setFinish] = useState(true);
  const [language, setLanguage] = useState("si");
  const [useLanguage, setUseLanguage] = useState("si");
  const [formData, setFormData] = useState({
    category: {
      key: "category",
      label: "Category",
      size: "lg",
      placeholder: "-",
      mainLayerStyles: " flex-column " + " align-content-center " + "mb-3",
      iconName: "",
      isRequired: false,
      loading: false,
      elementConfig: {
        options: [],
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    url: {
      key: "url",
      label: "Youtube URL",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    code: {
      key: "code",
      label: "YouTube embed code",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    titleSI: {
      key: "titleSI",
      label: "Title (SI)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionSI: {
      key: "descriptionSI",
      label: "Description (SI)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    titleEN: {
      key: "titleEN",
      label: "Title (EN)",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
      mainLayerStyles: "mb-3",
    },
    descriptionEN: {
      key: "descriptionEN",
      label: "Description (EN)",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "-",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
    imageUrl: {
      key: "imageUrl",
      size: "lg",
      isShowRequired: false,
      elementConfig: {
        type: "text",
        placeholder: "Type your image URL",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const [imageGallery, setImageGallery] = useState([]);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { selectNews, isOpenAddUpdateNewsModal } = useSelector(
    ({ newsReducer }) => newsReducer
  );

  const categoryList = useSelector(
    (state) => state.categoryReducer.categoryList
  );

  const dispatch = useDispatch();

  const handleChange = async (event, inputIdentity) => {
    const updateNewsForm = {
      ...formData,
    };

    updateNewsForm[inputIdentity].value = event;
    let validityRes = await CheckValidity(
      inputIdentity,
      updateNewsForm[inputIdentity].value,
      updateNewsForm[inputIdentity].validation
    );

    if (validityRes) {
      updateNewsForm[inputIdentity].isValid = validityRes.isValid;
      updateNewsForm[inputIdentity].invalidReason = validityRes.reason;
      updateNewsForm[inputIdentity].value = event;
      updateNewsForm[inputIdentity].touched = true;
      console.log("required_validation", validityRes);

      let formIsValid = false;
      for (let inputIdentifier in updateNewsForm) {
        formIsValid = updateNewsForm[inputIdentifier].valid && formIsValid;
      }
      console.log("formIsValid", formIsValid);
      setFormData(updateNewsForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setImage([]);
    setImageGallery([]);
    setFinish(true);
    setFormData(updateNewsForm);
  };

  const onClickAdd = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    const updateForm = { ...formData };
    if (updateForm.imageUrl.value === "") {
      setIsLoading(false);
      return;
    }
    let file = {
      url: updateForm.imageUrl.value,
      caption: {
        si: updateForm.imageUrl.value,
        en: updateForm.imageUrl.value,
      },
    };
    setImage([file]);
    setFormData({
      ...formData,
      imageUrl: {
        ...formData.imageUrl,
        value: "",
        isValid: false,
        touched: false,
      },
    });
    setIsLoading(false);
  };

  const onClickUpdate = async () => {
    setIsLoading(true);
    if (selectNews?.news_id) {
      const updateNewsForm = {
        ...formData,
      };

      let body = {
        title: {
          si: updateNewsForm.titleSI.value,
          en: updateNewsForm.titleEN.value,
        },
        content: {
          si: updateNewsForm.descriptionSI.value,
          en: updateNewsForm.descriptionEN.value,
        },
        author: "Damith",
        tags: [],
        category: updateNewsForm.category.value,
        status: "Draft",
        images: image,
        gallery: imageGallery,
        youtube_url: updateNewsForm.url.value,
        youtube_embed_code: updateNewsForm.code.value,
        language: useLanguage,
      };

      console.log("news body::", body);
      try {
        const response = await addUpdateNews(body, selectNews?.news_id);
        if (response?.data) {
          Store.addNotification({
            title: "Success!",
            message: "News Update Successfully!",
            type: "success",
            insert: "top",
            container: "top-right",
            dismiss: { duration: 3000, onScreen: true },
          });
          setIsLoading(false);
          setFinish(true);
          clearAll();
          dispatch(clearSelectNews());
          dispatch(closeAddUpdateNewsModal());
        }
      } catch (error) {
        console.error("Error creating news:", error);
        setIsLoading(false);
        Store.addNotification({
          title: "Error!",
          message: "Error creating news",
          type: "danger",
          insert: "top",
          container: "top-right",
          dismiss: {
            duration: 2000,
            onScreen: true,
          },
        });
      }
    }
  };

  const updateNewsForm = { ...formData };

  // scrollbars start
  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener("resize", updateWindowDimensions);
    window.addEventListener("scroll", handleOnScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return () => {
      window.removeEventListener("scroll", handleOnScroll);
      window.removeEventListener("resize", updateWindowDimensions);
    };
  }, []);

  const updateWindowDimensions = () => {
    setViewPointWidth(window.innerWidth);
    setViewPointHeight(window.innerHeight);
  };

  const handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };
  // scrollbars end

  const categorySelect = (value) => {
    console.log({ value });
    const updateNewsForm = { ...formData };
    updateNewsForm["category"].value = value;
    setFormData(updateNewsForm);
  };

  const onChangeImageGallery = (gallery) => {
    if (gallery) {
      setImageGallery(gallery);
    }
  };

  const onChangeImage = (image) => {
    try {
      if (image) {
        let file = {
          url: image.file_url,
          caption: {
            si: image.file_name,
            en: image.file_name,
          },
        };
        setImage([file]);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const onClickRemoveImage = async (key) => {
    try {
      const res = await deleteImage(key);
      console.log("remove image", res);

      setImage((prev) => {
        return prev.filter((item) => item.caption.si !== key);
      });
    } catch (error) {
      console.log("Error in deleting image", error);
    }
  };

  const onChangeSI = (form) => {
    if (form) {
      setFormData({
        ...formData,
        titleSI: form.titleSI,
        descriptionSI:
          form.descriptionSI === "" || form.descriptionSI === "<p></p>\n"
            ? formData.descriptionSI
            : form.descriptionSI,
      });
      setFinish(false);
    }
  };

  const onChangeEN = (form) => {
    if (form) {
      setFormData({
        ...formData,
        titleEN: form.titleEN,
        descriptionEN:
          form.descriptionEN === "" || form.descriptionEN === "<p></p>\n"
            ? formData.descriptionEN
            : form.descriptionEN,
      });
      setFinish(false);
    }
  };

  const onChange = (key) => {
    console.log(key);
    setLanguage(key);
  };
  const items = [
    {
      key: "si",
      label: "Sinhala",
      children: <Sinhala finish={finish} onChange={onChangeSI} />,
    },
    {
      key: "en",
      label: "English",
      children: <English finish={finish} onChange={onChangeEN} />,
    },
  ];

  const fetchCategoryName = (categoryId) => {
    const category = categoryList?.find(
      (category) => category.category_id === categoryId
    );
    return category ? category.name[lan] : "-";
  };

  useEffect(() => {
    if (selectNews?.news_id && isOpenAddUpdateNewsModal) {
      clearAll();
      let updateFormData = { ...formData };
      updateFormData.category.value = selectNews?.category;
      setUseLanguage(selectNews?.language);
      setFormData(updateFormData);
    }
  }, [selectNews, isOpenAddUpdateNewsModal]);

  return (
    <>
      <div
        className={`common-modal-out-bg-wrapper ${
          isOpenAddUpdateNewsModal ? "open_me" : "close__me"
        }`}
      />
      <div
        className={`common-modal-base-wrapper modal-container d-flex flex-column  animate__animated  ${
          isOpenAddUpdateNewsModal ? "open_me animate__bounceIn" : "close__me"
        }`}
      >
        <div className="common-modal-close">
          <ButtonIcon
            data={{ iconName: "cross", size: "sm" }}
            onClick={() => dispatch(closeAddUpdateNewsModal())}
          />
        </div>
        <div className="hne-create-news-wrapper">
          <FormHeader
            data={{
              formHeader: "Create new news",
              size: "md-md",
            }}
          />
          <Scrollbars
            onScroll={handleOnScroll}
            renderView={(props) => (
              <div {...props} style={{ ...props.style, overflowX: "hidden" }} />
            )}
            style={{ height: viewPointHeight - 230 }}
          >
            <div style={{ paddingBottom: "42px" }}>
              <>
                <div className={"hne-cnw-radio-button-wrapper"}>
                  <RadioButton
                    data={{
                      name: "Sinhala",
                      isActive: true,
                    }}
                    onClick={() => {
                      setUseLanguage("si");
                      onChange("si");
                    }}
                  />
                  <RadioButton
                    data={{
                      name: "English",
                      isActive: useLanguage === "en",
                    }}
                    onClick={() => {
                      setUseLanguage("en");
                      onChange("en");
                    }}
                  />
                  <RadioButton
                    data={{
                      name: "Multiple",
                      isActive: useLanguage === "multi",
                    }}
                    onClick={() => {
                      setUseLanguage("multi");
                    }}
                  />
                </div>
                <label className={"txt-label"}>Category</label>
                <div className="hne-category">
                  {fetchCategoryName(selectNews?.category)}
                </div>
                {/* <CategorySelectBox
                  onChangeCategory={categorySelect}
                  data={{
                    language: language,
                  }}
                /> */}
              </>
              <>
                <TabComponent items={items} onChange={onChange} />
              </>

              <div className={"hne-cnw-youtube "}>
                <InputBox
                  data={updateNewsForm.url}
                  onChange={async (e) => {
                    e.preventDefault();
                    await handleChange(e.target.value, updateNewsForm.url.key);
                  }}
                />
                <div className={"d-flex flex-column justify-content-start"}>
                  <InputBox
                    data={updateNewsForm.code}
                    onChange={async (e) => {
                      e.preventDefault();
                      await handleChange(
                        e.target.value,
                        updateNewsForm.code.key
                      );
                    }}
                  />
                  <div className={"uploader-lable"}>
                    Banner image (1000x 720)
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <InputBox
                      data={updateNewsForm.imageUrl}
                      onChange={async (e) => {
                        e.preventDefault();
                        await handleChange(
                          e.target.value,
                          updateNewsForm.imageUrl.key
                        );
                      }}
                    />
                    <div className="d-flex ml-2">
                      <Button
                        data={{
                          btnName: "Add",
                          buttonType: "secondary",
                          buttonSize: "md",
                          isLoading: isLoading,
                          disable:
                            updateNewsForm.imageUrl.value === "" ||
                            !updateNewsForm.imageUrl.isValid,
                        }}
                        onClick={async (e) => {
                          e.preventDefault();
                          await onClickAdd(e);
                        }}
                      />
                    </div>
                  </div>
                  {image?.length > 0 && (
                    <>
                      <ImageComponent
                        data={{ size: "md mt-3", imgUrl: image?.[0]?.url }}
                        onClickRemove={() => {
                          onClickRemoveImage(
                            image?.[0]?.caption?.si || image?.[0]?.caption?.en
                          );
                        }}
                      />
                    </>
                  )}
                  {image?.length === 0 && (
                    <Uploader
                      data={{
                        disabled: false,
                        isLable: true,
                        iconName: "upload-cloud",
                      }}
                      onChange={onChangeImage}
                    />
                  )}
                </div>

                <GalleryUploader
                  onChange={onChangeImageGallery}
                  data={{
                    images: imageGallery,
                  }}
                />
              </div>
            </div>
          </Scrollbars>
          <div
            className="d-flex flex-row justify-content-between"
            style={{ marginBottom: "15px" }}
          >
            {selectNews?.news_id && (
              <Button
                data={{
                  btnName: "Clear",
                  buttonType: "secondary mr-2",
                  buttonSize: "lg",
                  isLoading: isLoading,
                }}
                onClick={async (e) => {
                  e.preventDefault();
                  if (selectNews?.news_id) {
                    dispatch(clearSelectNews());
                    setFinish(true);
                    setUseLanguage("si");
                    setImage([]);
                    setImageGallery([]);
                    const updateNewsForm = {
                      ...formData,
                    };
                    for (let key in updateNewsForm) {
                      updateNewsForm[key].value = "";
                      updateNewsForm[key].isValid = false;
                      updateNewsForm[key].touched = false;
                    }
                    setFormData(updateNewsForm);
                  }
                }}
              />
            )}
            <Button
              data={{
                btnName: selectNews?.news_id ? "Update" : "Done",
                buttonType:
                  useLanguage === "" || updateNewsForm.category.value === ""
                    ? "primary disabled"
                    : useLanguage === "multi"
                    ? updateNewsForm.descriptionEN.value === "" ||
                      updateNewsForm.descriptionSI.value === "" ||
                      updateNewsForm.titleEN.value === "" ||
                      updateNewsForm.titleSI.value === ""
                      ? "primary disabled"
                      : "primary"
                    : useLanguage === "si"
                    ? updateNewsForm.descriptionSI.value === "" ||
                      updateNewsForm.titleSI.value === ""
                      ? "primary disabled"
                      : "primary"
                    : useLanguage === "en"
                    ? updateNewsForm.descriptionEN.value === "" ||
                      updateNewsForm.titleEN.value === ""
                      ? "primary disabled"
                      : "primary"
                    : "primary",
                buttonSize: "lg",
                isLoading: isLoading,
                disable:
                  useLanguage === "" || updateNewsForm.category.value === ""
                    ? true
                    : useLanguage === "multi"
                    ? updateNewsForm.descriptionEN.value === "" ||
                      updateNewsForm.descriptionSI.value === "" ||
                      updateNewsForm.titleEN.value === "" ||
                      updateNewsForm.titleSI.value === ""
                      ? true
                      : false
                    : useLanguage === "si"
                    ? updateNewsForm.descriptionSI.value === "" ||
                      updateNewsForm.titleSI.value === ""
                      ? true
                      : false
                    : useLanguage === "en"
                    ? updateNewsForm.descriptionEN.value === "" ||
                      updateNewsForm.titleEN.value === ""
                      ? true
                      : false
                    : false,
              }}
              onClick={async (e) => {
                e.preventDefault();
                if (selectNews?.news_id) {
                  await onClickUpdate(e);
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Index;
